<aside class="tj-main__sidebar tj-post-sidebar">
  <div
    id="search-2"
    class="tj-sidebar__widget tj-sidebar-widget widget_search"
  >
    <h5 class="tj-sidebar-widget-title">Buscar</h5>
    <div class="tj-widget__search sidebar-search">
      <form
        (submit)="onSearch($event)"
      >
        <input
          type="search"
          value=""
          required=""
          name="s"
          placeholder="Buscar..."
          [(ngModel)]="query"
        >
        <button type="submit"> <i class="material-symbols-outlined">search</i> </button>
      </form>
    </div>
  </div>


  @if (showRecentPosts()) {
  <div
    id="tj-recent-posts-2"
    class="tj-sidebar__widget tj-sidebar-widget tj_recent_posts"
  >
    <h5 class="tj-sidebar-widget-title"> Noticias Recientes </h5>

    <div class="sidebar-recent-post">

      @for (post of recentPosts(); track $index) {
      <div class="single-post d-flex align-items-center">
        <div class="post-image">
          <a
            [routerLink]="['/news', post.id]"
            class="relative"
          >
            <img
              [src]="post.imageUrl"
              class="attachment-thumbnail size-thumbnail wp-post-image w-[100px]!"
              alt=""
              decoding="async"
              sizes="(max-width: 150px) 100vw, 150px"
            >
            <span class="absolute top-0 left-0 w-full h-full bg-linear-to-b from-primary/5 to-primary/50"></span>
          </a>
        </div>
        <div class="post-header">
          <h6 class="title-link">
            <a [routerLink]="['/news', post.id]">
              {{post.title}}
            </a>
          </h6>
          <span class="date">{{post.date | date}}</span>
        </div>
      </div>
      }
    </div>


  </div>
  }

  <div class="tj-sidebar__widget tj-sidebar-widget widget_tag_cloud">
    <h5 class="tj-sidebar-widget-title">Tags</h5>
    <nav aria-label="Tags">
      <div class="tagcloud">
        @if (tags()) {
        @for (tag of tags().slice(0, showMoreTags() ? tags().length : 15); track $index) {
          <a
            [routerLink]="['/news/search/', tag.title]"
            rel="tag"
            class="lowercase text-xs! transition-all ease-in-out"
          >{{ tag.title }}</a>
        }
        }
      </div>

      @if (tags().length > 15 && !showMoreTags()) {
        <a (click)="showMoreTags.set(!showMoreTags())" 
        class="
          w-fit relative underline-effect before:bg-heading-primary! 
          lowercase text-xs! text-heading-primary font-semibold
          flex items-center gap-1 mt-4
          cursor-pointer
        ">
          Ver más
          <i class="material-symbols-outlined text-base! font-semibold">arrow_right_alt</i>
        </a>
      }
    </nav>
  </div>
</aside>